import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {WarningIcon} from 'shells/icon/svg/warning-icon';

import styles from './cards-error-state.module.css';

type Props = {
    // @ts-expect-error
    errorMessage: string | React.ReactElement<React.ComponentProps<string>>;
};

export class CardsErrorState extends React.PureComponent<Props> {
    render() {
        return (
            <div className={styles['cards-error-state']}>
                <div className='mb-16'>
                    {/* @ts-expect-error */}
                    <WarningIcon color={colors.rose} size={17} />
                </div>
                <div className={styles['error-text']}>{this.props.errorMessage}</div>
            </div>
        );
    }
}
